/**
 * Normalizes text for search and filtering:
 * - Converts to lower case
 * - Decomposes diacritics via NFD (e.g. 'á' -> 'a' + '\u0301', 'ñ' -> 'n' + '\u0303')
 * - Strips combining diacritical marks (\u0300-\u036f)
 * - Trims extra whitespace
 */
export function normalizeSearchText(text) {
  return (text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
}

/**
 * Normalizes a player name or identifier for exact slug-like matching:
 * Strips all non-alphanumeric characters after accent removal and lowercasing.
 * e.g. "Álex Padilla" -> "alexpadilla", "Iñaki Williams" -> "inakiwilliams"
 */
export function normalizePlayerIdentifier(text) {
  return normalizeSearchText(text).replace(/[^a-z0-9]/g, '');
}

/**
 * Checks whether a candidate string matches a search query, insensitive to accents and case.
 */
export function matchesSearch(candidate, query) {
  const normQuery = normalizeSearchText(query);
  if (!normQuery) return true;
  return normalizeSearchText(candidate).includes(normQuery);
}
flarum.reg.add('nagusi-match-ratings', 'common/utils/normalize', { normalizeSearchText: normalizeSearchText,normalizePlayerIdentifier: normalizePlayerIdentifier,matchesSearch: matchesSearch, });